import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

// Service
import { LimitFlowProposalService } from '../../..//service/limit-flow-proposal/limit-flow-proposal.service';
import { CommonService } from '../../../../common/service/common.service';

// Models
import { Meses } from '../../../../models/meses';

@Component({
	moduleId: module.id,
	selector: 'culture',
	templateUrl: 'culture.component.html',
	styleUrls: ['./culture.component.scss'],
	providers: [
		CommonService
	]
})
export class CultureComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";	
	@Input('proposalLayout') proposalLayout: number = 0;
	@Input('cultureObj') cultureObj: any[] = [];
	@Input('proposalStatus') proposalStatus: string = "";
	@Input('profileUser') profileUser: string = "";	
	@Input('currentTab') currentTab: string = "";	
	@Input('isProposalRevenue') isProposalRevenue: string = "";
	@Input('proposalRevenueDocument') proposalRevenueDocument: string = "";
	@Input('isUserOwner') isUserOwner: boolean = false;

	private token;
	public productivitys: any[] = [];
	public cultures;
	public areas: any[] = [];
	public states: any[] = [];
	public citys: any[] = [];
	public proposalCultures: any[] = [];
	public months: Meses;
	public editCultureIndex: number = undefined;
	culture: FormGroup;

	constructor(private fb: FormBuilder, private flashMessagesService: FlashMessagesService, private limitFlowProposalService: LimitFlowProposalService, private commonService: CommonService) {

		this.months = new Meses();

		this.culture = fb.group({
			ID: '',			
			CulturaID: ['', Validators.compose([Validators.required])],
			EstadoID: ['', Validators.compose([Validators.required])],
			CidadeID: ['', Validators.compose([Validators.required])],
			UnidadeMedida: '',
			Area: '',
			Arrendamento: '',
			ProdutividadeMedia: ['', Validators.compose([Validators.required])],
			Preco: ['', Validators.compose([Validators.required])],
			CustoHa: ['', Validators.compose([Validators.required])],
			ConsumoFertilizante: ['', Validators.compose([Validators.required])],
			PrecoMedioFertilizante: '',
			MesPlantio: ['', Validators.compose([Validators.required])],
			MesColheita: ['', Validators.compose([Validators.required])],
			Quebra: '',
			CustoArrendamentoSacaHa: ''
		});
	}

	ngOnInit() {
		this.token = localStorage.getItem('yara.token');
		//this.getProductivity();
		this.getState();
		this.getCultures();
		this.getAreas();
		$("#totalReceitaLiquidaCultura").val(this.getTotalReceitaLiquida());
		$("#receitaLiquidaCultura").val(this.getTotalReceitaLiquida());
		$("#receitaBrutaCultura").val(this.getTotalReceitaBruta());
		$("#receitaBrutaTotal").val(this.getReceitaBrutaTotal());
		
		setTimeout(function(){ 
			($('[data-toggle="culture-tooltip"]') as any).tooltip();
		}, 0);
	}

	getReceitaBruta(i) {
		var porcentagem = parseFloat(this.limitFlowProposalService.culturesObj[i].Quebra);
		var count = porcentagem ? 1 - (porcentagem / 100) : 1;

		return (this.limitFlowProposalService.culturesObj[i].Area + this.limitFlowProposalService.culturesObj[i].Arrendamento) * this.limitFlowProposalService.culturesObj[i].ProdutividadeMedia * this.limitFlowProposalService.culturesObj[i].Preco * count; 
	}

	getNecessidadeFertilizante(i) {
		return ((this.limitFlowProposalService.culturesObj[i].Area + this.limitFlowProposalService.culturesObj[i].Arrendamento) * this.limitFlowProposalService.culturesObj[i].ConsumoFertilizante) / 1000;
	}

	getNecessidadeFertilizanteRS(i) {
		return this.limitFlowProposalService.culturesObj[i].PrecoMedioFertilizante * this.getNecessidadeFertilizante(i);
	}

	getCustosTotais(i) {
		return ((this.limitFlowProposalService.culturesObj[i].Area + this.limitFlowProposalService.culturesObj[i].Arrendamento) * this.limitFlowProposalService.culturesObj[i].CustoHa) + 
		((this.limitFlowProposalService.culturesObj[i].Preco * this.limitFlowProposalService.culturesObj[i].CustoArrendamentoSacaHa) * this.limitFlowProposalService.culturesObj[i].Arrendamento);
	}

	getReceitaLiquida(i) {
		return this.getReceitaBruta(i) - this.getCustosTotais(i);
	}

	getNecessidadeFertilizanteRSTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.culturesObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.culturesObj[i].Documento === this.proposalRevenueDocument) {
				sum += this.getNecessidadeFertilizanteRS(i);
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.culturesObj[i].Documento) {
				sum += this.getNecessidadeFertilizanteRS(i);
			}
		}

		$("#receitaTotal").val(sum);

		return sum;
	}

	getTotalReceitaLiquida() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.culturesObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.culturesObj[i].Documento === this.proposalRevenueDocument) {
				sum += this.getReceitaLiquida(i);
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.culturesObj[i].Documento) {
				sum += this.getReceitaLiquida(i);
			}
		}

		return sum;
	}

	getTotalReceitaBruta() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.culturesObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.culturesObj[i].Documento === this.proposalRevenueDocument) {
				sum += this.getReceitaBruta(i);
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.culturesObj[i].Documento) {
				sum += this.getReceitaBruta(i);
			}
		}

		return sum;
	}

	setUnidadeMedida(cultureID) {	

		for (var key in this.cultures) {
			var obj = this.cultures[key];
			if (obj.ID === cultureID) {
				var data = obj;
			}
		}

		if (data) {
			this.culture.controls["UnidadeMedida"].setValue(data.UnidadeMedida);
		} else {
			this.flashMessagesService.show("Ocorreu um erro ao carregar a unidade de medida. Verifique o cadastro", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}


	percentualCheck(e) {
		if (e.target.value.length > e.target.maxLength) {
			e.target.value = e.target.value.slice(0, e.target.maxLength);
		} else {
			if (e.target.value > 100) {
				e.target.value = 100;
			} else if (e.target.value < 0) {
				e.target.value = 0;
			}
		}
	}

	setQuebra(e ,i) {
		this.percentualCheck(e);
		this.limitFlowProposalService.culturesObj[i].Quebra = e.target.value;
		$("#totalReceitaLiquidaCultura").val(this.getTotalReceitaLiquida());
		$("#receitaLiquidaCultura").val(this.getTotalReceitaLiquida());
		$("#receitaBrutaCultura").val(this.getTotalReceitaBruta());
		$("#receitaBrutaTotal").val(this.getReceitaBrutaTotal());
	}

	setCustoArrendamento(e, i) {
		this.limitFlowProposalService.culturesObj[i].CustoArrendamentoSacaHa = e.target.value;
		$("#totalReceitaLiquidaCultura").val(this.getTotalReceitaLiquida());
		$("#receitaLiquidaCultura").val(this.getTotalReceitaLiquida());
		$("#receitaBrutaCultura").val(this.getTotalReceitaBruta());
		$("#receitaBrutaTotal").val(this.getReceitaBrutaTotal());
	}

	saveCulture(culture: any) {		

		culture.Cidade = this.setCidadeEstado(culture.CidadeID);
		culture.Cidade = culture.Cidade[0];
		culture.Documento = this.proposalRevenueDocument;
		
		this.limitFlowProposalService.getCultureInfos(culture.EstadoID, culture.CulturaID).subscribe(result => {
			if (result.Success) {
				if (result.Result) {
				// Salva os dados padrão para cultura/estado na cultura inserida
				culture.PorcentagemFertilizanteCusto = result.Result ? result.Result.PorcentagemFertilizanteCusto : "";
				culture.PrecoPadrao = result.Result ? result.Result.Preco : "";
				culture.ProdutividadeMediaPadrao = result.Result ? result.Result.ProdutividadeMedia : "";
				culture.CustoPadrao = result.Result ? result.Result.Custo : "";
			}

			this.limitFlowProposalService.culturesObj.push(culture);

			$("#totalReceitaLiquidaCultura").val(this.getTotalReceitaLiquida());
			$("#receitaLiquidaCultura").val(this.getTotalReceitaLiquida());
			$("#receitaBrutaCultura").val(this.getTotalReceitaBruta());
			$("#receitaBrutaTotal").val(this.getReceitaBrutaTotal());
			
			this.flashMessagesService.show("Cultura adicionada", { cssClass: 'alert-success', timeout: 6000 });
			this.culture.reset();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);	
		})
		
	}

	deleteProposalCulture(index) {
		this.limitFlowProposalService.culturesObj.splice(index, 1);
		$("#totalReceitaLiquidaCultura").val(this.getTotalReceitaLiquida());
		$("#receitaLiquidaCultura").val(this.getTotalReceitaLiquida());
		$("#receitaBrutaCultura").val(this.getTotalReceitaBruta());
		$("#receitaBrutaTotal").val(this.getReceitaBrutaTotal());
		this.flashMessagesService.show("Cultura removida", { cssClass: 'alert-success', timeout: 6000 });
	}

	editCulture(index) {
		this.editCultureIndex = index;
		($(".cultures-list table tbody tr")as any).eq(index).addClass("edit-line");
		($(".cultures-form")as any).addClass("editing");
		var stateID = this.limitFlowProposalService.culturesObj[index].EstadoID ? this.limitFlowProposalService.culturesObj[index].EstadoID : this.limitFlowProposalService.culturesObj[index].Cidade.EstadoID;
		this.getCity(stateID, true, index);
	}

	saveCultureEdit(index) {
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].CulturaID = this.culture.controls['CulturaID'].value;
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].EstadoID = this.culture.controls['EstadoID'].value;
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].CidadeID = this.culture.controls['CidadeID'].value;
		var cidade = this.setCidadeEstado(this.culture.controls['CidadeID'].value);
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].Cidade = cidade[0];
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].UnidadeMedida = this.culture.controls['UnidadeMedida'].value;
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].Area = this.culture.controls['Area'].value;
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].Arrendamento = this.culture.controls['Arrendamento'].value;
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].ProdutividadeMedia = this.culture.controls['ProdutividadeMedia'].value;
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].Preco = this.culture.controls['Preco'].value;
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].CustoHa = this.culture.controls['CustoHa'].value;
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].ConsumoFertilizante = this.culture.controls['ConsumoFertilizante'].value;
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].PrecoMedioFertilizante = this.culture.controls['PrecoMedioFertilizante'].value;
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].MesPlantio = this.culture.controls['MesPlantio'].value;
		this.limitFlowProposalService.culturesObj[this.editCultureIndex].MesColheita = this.culture.controls['MesColheita'].value;

		this.editCultureIndex = undefined;
		this.culture.reset();
		($(".cultures-list table tbody tr") as any).removeClass("edit-line");
		($(".cultures-form")as any).removeClass("editing");
		$("#totalReceitaLiquidaCultura").val(this.getTotalReceitaLiquida());
		$("#receitaLiquidaCultura").val(this.getTotalReceitaLiquida());
		$("#receitaBrutaCultura").val(this.getTotalReceitaBruta());
		$("#receitaBrutaTotal").val(this.getReceitaBrutaTotal());
		
		setTimeout(function(){ 
			($('[data-toggle="culture-tooltip"]') as any).tooltip();
		}, 0);
	}

	cancelCultureEdit() {
		this.editCultureIndex = undefined;
		($(".cultures-list table tbody tr") as any).removeClass("edit-line");
		($(".cultures-form")as any).removeClass("editing");
		this.culture.reset();
	}

	getTotalAreas() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.culturesObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.culturesObj[i].Documento === this.proposalRevenueDocument) {
				sum += this.limitFlowProposalService.culturesObj[i].Area;
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.culturesObj[i].Documento) {
				sum += this.limitFlowProposalService.culturesObj[i].Area;
			}
		}

		return sum;
	}

	getTotalAreaArrendada() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.culturesObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.culturesObj[i].Documento === this.proposalRevenueDocument) {
				sum += this.limitFlowProposalService.culturesObj[i].Arrendamento;
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.culturesObj[i].Documento) {
				sum += this.limitFlowProposalService.culturesObj[i].Arrendamento;
			}
		}

		return sum;
	}

	getTotalNecessidadeFertilizante() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.culturesObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.culturesObj[i].Documento === this.proposalRevenueDocument) {
				sum +=  this.limitFlowProposalService.culturesObj[i].PrecoMedioFertilizante * this.getNecessidadeFertilizante(i);
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.culturesObj[i].Documento) {
				sum +=  this.limitFlowProposalService.culturesObj[i].PrecoMedioFertilizante * this.getNecessidadeFertilizante(i);
			}
		}

		return sum;
	}


	getReceitaBrutaTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.culturesObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.culturesObj[i].Documento === this.proposalRevenueDocument) {
				sum +=  this.getReceitaBruta(i);
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.culturesObj[i].Documento) {
				sum +=  this.getReceitaBruta(i);
			}
		}

		$("#receitaBrutaTotal").val(sum);

		return sum;
	}

	getCustoTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.culturesObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.culturesObj[i].Documento === this.proposalRevenueDocument) {
				sum +=  this.getCustosTotais(i);
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.culturesObj[i].Documento) {
				sum +=  this.getCustosTotais(i);
			}
		}

		return sum;
	}

	getReceitaLiquidaTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.culturesObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.culturesObj[i].Documento === this.proposalRevenueDocument) {
				sum +=  this.getReceitaLiquida(i);
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.culturesObj[i].Documento) {
				sum +=  this.getReceitaLiquida(i);
			}
		}

		return sum;
	}

	getProductivity() {
		this.limitFlowProposalService.getProductivity(this.token).subscribe(result => {
			if (result.Success) {
				this.productivitys = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);	
		})
	}

	getAreas() {
		this.limitFlowProposalService.getArea(this.token).subscribe(result => {
			if (result.Success) {
				this.areas = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	getCulturaDesc(CulturaID) {
		var desc; 
		var item = this.cultures ? this.cultures.filter(item => item.ID === CulturaID) : [];
		desc = item[0] ? item[0].Descricao : "";
		return desc; 
	}

	getEstadoDesc(stateID) {
		var desc; 
		var item = this.states.filter(item => item.ID === stateID);
		desc = item[0] ? item[0].Nome : "";
		return desc; 
	}

	setCidadeEstado(cityID) {
		return this.citys.filter(item => item.ID === cityID);
	}

	getCultures() {
		this.limitFlowProposalService.getCulture(this.token).subscribe(result => {
			if (result.Success) {
				this.cultures = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);	
		})
	}

	getState() {
		this.commonService.getState(this.token).subscribe(result => {
			if (result.Success) {
				this.states = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);	
		})
	}

	getCity(stateID, setCity, index) {
		console.log(stateID);
		this.commonService.getCity(this.token, stateID).subscribe(result => {
			if (result.Success) {
				this.citys = result.Result;

				if (setCity) {
					//this.setCity(index);
					this.culture.patchValue({
						CulturaID: this.limitFlowProposalService.culturesObj[index].CulturaID,
						EstadoID: this.limitFlowProposalService.culturesObj[index].EstadoID ? this.limitFlowProposalService.culturesObj[index].EstadoID : this.limitFlowProposalService.culturesObj[index].Cidade.EstadoID,
						CidadeID: this.limitFlowProposalService.culturesObj[index].CidadeID,
						UnidadeMedida: this.limitFlowProposalService.culturesObj[index].UnidadeMedida,
						Area: this.limitFlowProposalService.culturesObj[index].Area,
						Arrendamento: this.limitFlowProposalService.culturesObj[index].Arrendamento,
						ProdutividadeMedia: this.limitFlowProposalService.culturesObj[index].ProdutividadeMedia,
						Preco: this.limitFlowProposalService.culturesObj[index].Preco,
						CustoHa: this.limitFlowProposalService.culturesObj[index].CustoHa,
						ConsumoFertilizante: this.limitFlowProposalService.culturesObj[index].ConsumoFertilizante,
						PrecoMedioFertilizante: this.limitFlowProposalService.culturesObj[index].PrecoMedioFertilizante,
						MesPlantio: this.limitFlowProposalService.culturesObj[index].MesPlantio,
						MesColheita: this.limitFlowProposalService.culturesObj[index].MesColheita
					});

					this.setUnidadeMedida(this.limitFlowProposalService.culturesObj[index].CulturaID);
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);	
		})
	}
}






// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/culture/culture.component.ts